/**
 * `window` CustomEvent names for in-app communication within the chat iframe.
 * Not the same as CHATYME_EMBED_HOST_MESSAGE_TYPE (postMessage to parent).
 */
export const CHATYME_WINDOW_EVENT = {
  AGENT_CONFIG_UPDATED: 'chatyme:agent-config-updated',
} as const;

export type ChatymeWindowEventValue =
  (typeof CHATYME_WINDOW_EVENT)[keyof typeof CHATYME_WINDOW_EVENT];
